import { forwardRef } from 'react'
import { EditorContent } from '@tiptap/react'
import MentionSuggestionsPopover from '@/components/AiAskBar/MentionSuggestionsPopover'
import { useComposerEditorModel } from './useComposerEditorModel'

const ComposerEditor = forwardRef(function ComposerEditor(props, ref) {
  const {
    editor,
    enableMentions,
    mentionRefs,
    mentionUsers,
    mentionAgentsList,
    insertMention,
  } = useComposerEditorModel(props, ref)

  if (!editor) return null

  return (
    <>
      <EditorContent editor={editor} />
      {enableMentions ? (
        <MentionSuggestionsPopover
          open={Boolean(mentionRefs.mentionTrigger && mentionRefs.mentionAnchor)}
          anchorEl={mentionRefs.mentionAnchor}
          users={mentionUsers}
          agents={mentionAgentsList}
          activeIndex={mentionRefs.mentionActiveIndex}
          onHighlight={mentionRefs.setMentionActiveIndex}
          onSelect={insertMention}
        />
      ) : null}
    </>
  )
})

export default ComposerEditor
